import React, { useEffect, useState } from "react";
import { string, object, number, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Carousel from "../../atoms/Carousel";
import FocusedCard from "../../atoms/FocusedCard";
import { getSlug } from "../../utils/utils";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import "./sliderFocusedCard.m.css";

const SliderFocusedCard = ({ collection, sections, domainSlug, publisherAttributes }) => {
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
    global.deviceWidth > 875 && global.deviceWidth < 1264 && setIsTab(!isTab);
    global.deviceWidth > 1263 && setIsDesktop(!isDesktop);
  }, []);

  const stories = collection.items.filter(item => item.type === "story").map(item => item.story);
  const slides = stories
    .slice(0, 9)
    .map(story => (
      <FocusedCard
        key={story.id}
        story={story}
        styleName="card"
        updatedFont={true}
        publisherLang={publisherAttributes.lang}
      />
    ));
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  if (stories.length < 0) {
    return null;
  }

  return (
    <div styleName="base" className="slider-focused-card" data-testid="slider-story-cards">
      <div styleName="carousel-wrapper">
        {showCollectionName && collection.name && (
          <CollectionTitleWithArrow
            collectionName={collection.name}
            collectionSlug={collectionSlug}
            updatedFont={true}
          />
        )}
        {(isMobile && stories.length > 1) || (isTab && stories.length > 3) || (isDesktop && stories.length > 4) ? (
          <Carousel
            carouselName={"carousel-" + collection.id}
            options={{
              type: "carousel",
              perView: 4,
              gap: 20,
              rewind: false,
              breakpoints: {
                875: {
                  perView: 1
                },
                1264: {
                  perView: 3,
                  gap: 20
                }
              }
            }}
            renderCenterLeftControls={({ previousSlide, currentSlide }) =>
              !isMobile &&
              (currentSlide > 0 ? (
                <button aria-label="previous slide" role="button" onClick={previousSlide}>
                  <LeftArrowButton color="#121212" />
                </button>
              ) : null)
            }
            renderCenterRightControls={({ nextSlide, currentSlide }) =>
              !isMobile &&
              (currentSlide < 5 ? (
                <button aria-label="next slide" role="button" onClick={nextSlide}>
                  <RightArrowButton color="#121212" />
                </button>
              ) : null)
            }
          >
            {slides}
          </Carousel>
        ) : (
          <div styleName="story-cards">{slides}</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

SliderFocusedCard.propTypes = {
  accentColor: string,
  collection: object,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  sections: array,
  publisherAttributes: object,
  domainSlug: string
};

export default connect(mapStateToProps, null)(SliderFocusedCard);
